import React, { Component } from "react";
import TestDescription from "../../../common/testDescription/testDescription";
import Loader from "../../../common/loader/loader";
import axios from "axios";
import $ from "jquery";
import test9json from "./test9quiz";

class Test8 extends Component {
    state = {
        title: null,
        description: null,
        isTrialNeeded: null,
        percent: null,
        allTests: [],
        isTestChosen: null,
        done: null,
        answers: null,
        answerTestName: null,
        loading : false,
        loadError : false,
        errorMessage: null
    };
    backToTest = () => {
        let isTestChosen = false;
        this.setState({ isTestChosen });
    };

    assignTestProperties = elem => {
        let title = elem.test.title;
        let description = elem.test.desc;
        let id = elem.id;
        let done = elem.done;
        let isTestChosen = true;
        let answers = elem.answers;
        let answerTestName = "Test9";
        this.setState({
            title,
            description,
            id,
            isTestChosen,
            done,
            answers,
            answerTestName
        });
        // console.log(elem);
        this.props.setDescription(description);
    };

    assignTestAnswers = (allTest, string) => {
        let allTests = allTest;
        allTests.map(elem => {
            console.log(elem);
            $.ajax({
                headers: {
                    "X-CSRF-TOKEN": string
                },
                url: "http://psychologytest.tsu.ge/backend/answer/cnobisanswer",
                dataType: "json",
                type: "POST",
                data: {
                    id: elem.id
                },
                success: responses => {
                    console.log(responses.length);
                    if (Object.keys(responses).length > 0) {
                        elem.done = true;
                        elem.answers = responses;
                    } else {
                        elem.done = false;
                    }
                },
                error: responses => {
                    console.log(responses);
                }
            });
        });

        this.setState({ allTests });
    };
    componentDidMount() {
        let isTestChosen = false;
        this.setState({ isTestChosen });
        let allTests = [];

        // console.log(test8json);
        // const title = test9json["4"].title;
        // const description = test9json["4"].desc;
        // this.setState({title, description})
        // console.log(title)
        let string = "";
        let isTrialNeeded = this.state.isTrialNeeded;
        let percent = this.state.percent;
        let loading = this.state.loading;
        loading = true;
        this.setState({loading});
        axios
            .get("http://psychologytest.tsu.ge/backend/studenti/tocken")
            .then(response => {
                string = response.data.token;
                // let startIndex =
                //     string.indexOf('<meta name="csrf-token" content="') +
                //     '<meta name="csrf-token" content="'.length;
                // let lastIndex = null;

                // for (let i = startIndex; i < string.length; i++) {
                //     if (string[i] === '"') {
                //         lastIndex = i;
                //         break;
                //     }
                // }
                // string = string.substring(startIndex, lastIndex);
                console.log(string);

                $.ajax({
                    headers: {
                        "X-CSRF-TOKEN": string
                    },
                    url: "http://psychologytest.tsu.ge/backend/user/cnobisJson",
                    dataType: "json",
                    type: "POST",
                    success: response => {
                        let title = "";
                        let description = "";
                        for (let test in response) {
                            if (
                                response[test].proc === "" ||
                                response[test].proc === undefined
                            ) {
                                title = response[test].title;
                                description = response[test].desc;
                            }
                            if (response[test].proc !== "") {
                                isTrialNeeded = true;
                                percent = parseInt(response[test].proc);
                                this.setState({ isTrialNeeded, percent });
                            }
                            let singleTest = {};
                            singleTest.id = test;
                            singleTest.test = response[test];
                            singleTest.done = false;
                            singleTest.answers = [];

                            allTests.push(singleTest);
                        }
                        this.setState({ title, description });
                        this.props.setDescription(description);
                        this.assignTestAnswers(allTests, string);
                        loading = false;
                        this.setState({loading});
                    },
                    error: response =>{
                        console.log(response);
                        loading = false;
                        let loadError = this.state.loadError;
                        loadError = true;
                        this.setState({loading, loadError, errorMessage: response});
                    }
                });
            })
            .catch(error => {
                console.log(error);
                loading = false;
                let loadError = this.state.loadError;
                loadError = true;
                this.setState({loading,loadError, errorMessage: error});
            });
    }
    render() {
        const {
            title,
            description,
            isTrialNeeded,
            percent,
            isTestChosen,
            allTests,
            id,
            done,
            answers,
            answerTestName
        } = { ...this.state };
        let element = null;
        let elementToShow = null;
        if (isTestChosen) {
            element = (
                <React.Fragment>
                    <TestDescription
                        title={title}
                        description={description}
                        url={"Test9/modes"}
                        findIfTrialNeeded={this.props.findIfTrialNeeded}
                        isTrialNeeded={isTrialNeeded}
                        testName={"istest9TrialNeeded"}
                        testPercent={"test9Percent"}
                        percent={percent}
                        updateTestPercent={this.props.updateTestPercent}
                        backToTest={this.backToTest}
                        id={id}
                        done={done}
                        answers={answers}
                        answerTestName={answerTestName}
                        updateDescVisibility={this.props.updateDescVisibility}
                    />
                </React.Fragment>
            );
            elementToShow = element;
        } else {
            if (allTests) {
                element = allTests.map((elem, i) => {
                    if (
                        elem.test.proc === "" ||
                        elem.test.proc === undefined ||
                        elem.test.proc === null
                    ) {
                        return (
                            <li
                                key={i}
                                className={`all-test-list ${
                                    elem.done ? "done" : "not-done"
                                }`}
                                onClick={() => {
                                    this.assignTestProperties(elem);
                                }}
                            >
                                <span></span>
                                <h3>{elem.test.title}</h3>
                            </li>
                        );
                    }
                });
                elementToShow = (
                    <div className="answer-test-list">
                        <ul className="answer-test-list-ul">{element}</ul>
                    </div>
                );
            }
        }
        let someTextToShow;
        if(this.state.loading){
            someTextToShow = <Loader/>
        }
        else{
            if(this.state.loadError){
                console.log(this.state.errorMessage.message)
                alert(`ტესტი ვერ ჩაიტვირთა : ${this.state.errorMessage.message}`);
            }
            else{
                someTextToShow = elementToShow;
            }
        }
        return <section className="type-holder">{someTextToShow}</section>;


        // return <React.Fragment>
        //             <TestDescription
        //                 title={title}
        //                 description={description}
        //                 url={"Test9/modes"}
        //                 findIfTrialNeeded={this.props.findIfTrialNeeded}
        //                 isTrialNeeded={isTrialNeeded}
        //                 testName={"istest9TrialNeeded"}
        //                 testPercent={"test9Percent"}
        //                 percent={percent}
        //                 updateTestPercent={this.props.updateTestPercent}
        //                 backToTest={this.backToTest}
        //                 id={id}
        //                 done={done}
        //                 answers={answers}
        //                 answerTestName={answerTestName}
        //                 updateDescVisibility={this.props.updateDescVisibility}
        //             />
        //         </React.Fragment>
    }
}

export default Test8;
